import { Department, DepartmentUser } from '@/dto/company';
import { CosConfigDTO } from '@/dto/mediaData';
import { api } from '@/request/api';
import { InjectionKey } from 'vue';
import { createStore, Store, useStore as baseUseStore } from 'vuex';

export interface State {
  mediaDataConfig: CosConfigDTO;
  applicationInfo: {
    autoCompanyId: string;
    appid: string;
  };
  departmentUserList: DepartmentUser[];
  departmentList: Department[];
}

// eslint-disable-next-line symbol-description
export const key: InjectionKey<Store<State>> = Symbol();

export const store = createStore<State>({
  state: {
    mediaDataConfig: {
      bucket: '',
      region: '',
    },
    applicationInfo: {
      autoCompanyId: '',
      appid: '',
    },
    departmentUserList: [],
    departmentList: [],
  },
  mutations: {
    setCosConfig(state, config: CosConfigDTO) {
      state.mediaDataConfig = config;
    },
    setApplicationInfo(state, { autoCompanyId, appid }: { autoCompanyId: string; appid: string }) {
      if (autoCompanyId) {
        state.applicationInfo.autoCompanyId = autoCompanyId;
      }
      if (appid) {
        state.applicationInfo.appid = appid;
      }
    },
    setDepartmentUserList(state, userList: DepartmentUser[]) {
      state.departmentUserList = userList;
    },
    setDepartmentList(state, list: Department[]) {
      state.departmentList = list;
    },
  },
  actions: {
    async loadCosConfig(context) {
      const res = await api.getMediaDataConfig();
      context.commit('setCosConfig', res.data);
    },
    async loadDepartmentUserList(context) {
      const res = await api.getDepartmentUserList(1);
      if (res.data.userlist) {
        context.commit('setDepartmentUserList', res.data.userlist);
      }
    },
  },
  getters: {
    getDepartmentUserList(state) {
      return state.departmentUserList;
    },
  },
  modules: {},
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useStore() {
  return baseUseStore(key);
}
